import { getCampaignType } from '../../step-utils';

export const getPriorityOptions = i18n => [
  { key: 'Low', text: i18n.getString(_TL_('Low')) },
  { key: 'Medium', text: i18n.getString(_TL_('Medium')) },
  { key: 'High', text: i18n.getString(_TL_('High')) },
];

export const getShoppingSettingOptions = ({
  isSearch,
  settingScenarioName,
  i18n,
  productData,
  feedData,
  campaignSettings,
  activity,
  ccJsData,
  onStoreSelectionChange,
  onSalesCountryChange,
  onFeedLabelChange,
  setProductLoading,
  isCPSSelected,
  updateProductConditionOptions,
  updateChildLevelProductCondition,
  onSelectFilterProducts,
}) => {
  const campaignTypeConfig = getCampaignType(isSearch, campaignSettings);
  if (isSearch) {
    return {
      settingScenarioName,
      data: productData,
      feedData,
      model: campaignSettings,
      campaignType: campaignTypeConfig.CampaignType,
      campaignSubType: campaignTypeConfig.CampaignSubType,
      // campaignId: _.result(this.campaign, 'Id'),
      isStoreValid: true,
      activityLogger: activity,
      onStoreSelectionChange,
      onSalesCountryChange,
      onFeedLabelChange,
      setProductLoading,
      isSponsoredSettings: {
        isSponsoredCampaign: false,
        isSPBCampaign: false,
        isSPBOptInAvailable: false,
        shouldUseNewMmcApiForSpa: false,
        hideBid: false,
      },
      ccJsData,
      deps: {
        i18nNewDesign: i18n,
      },
      isCPSSelected,
      isAllFeedProducts: false,
      updateProductConditionOptions,
      updateChildLevelProductCondition,
      onSelectFilterProducts,
    };
  }
  return {
    settingScenarioName,
    data: productData,
    feedData,
    model: campaignSettings,
    campaignType: campaignTypeConfig.CampaignType,
    campaignSubType: campaignTypeConfig.CampaignSubType,
    activityLogger: activity,
    ccJsData,
    deps: {
      i18nNewDesign: i18n,
    },
    onSalesCountryChange,
    onStoreSelectionChange,
    onFeedLabelChange,
    setProductLoading,
    isCPSSelected,
    isAllFeedProducts: false,
  };
};
